import { c as _c } from "react/compiler-runtime";
import { menuItemVariants } from '@systemeio/components';
import { ChevronDownIcon } from '@systemeio/icons';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { NavigationMenu } from 'shared/components/navbar/components/navigation-menu';
import { DESKTOP_NAVBAR_CHEVRON_CHILD_CLASS_NAME, DESKTOP_NAVBAR_CHEVRON_CLASS_NAME, DESKTOP_NAVBAR_DROPDOWN_PADDING_CLASS_NAME, DESKTOP_NAVBAR_ITEM_LAYOUT_CLASS_NAME } from 'shared/components/navbar/constants';
import type { MenuDropdownItem, MenuItem, MenuLinkItem } from 'shared/components/navbar/types/menu-item';
import { hasRenderableMenuItem } from 'shared/components/navbar/utils/has-renderable-menu-item';
import { isNestedMenuItemActive } from 'shared/components/navbar/utils/is-menu-item-active';
import { isMenuLink } from 'shared/components/navbar/utils/is-menu-link';
import { twJoin, twMerge } from 'tailwind-merge';
interface DesktopMenuItemProps {
  item: MenuItem;
}

/** One `<li>` of the desktop navigation bar: either a flat link or a dropdown. */
export function DesktopMenuItem(t0) {
  const $ = _c(4);
  const {
    item
  } = t0;
  if (isMenuLink(item)) {
    let t1;
    if ($[0] !== item) {
      t1 = <DesktopFlatLink item={item} />;
      $[0] = item;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== item) {
    t1 = <DesktopDropdown item={item} />;
    $[2] = item;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export const getItemClassName = (isActive: boolean) => twMerge(DESKTOP_NAVBAR_ITEM_LAYOUT_CLASS_NAME, 'transition-base text-text-primary hover:bg-bg-tertiary transition-[background-color,color]', 'focus-visible:focus-ring-primary outline-none', isActive && 'text-text-link');
function DesktopFlatLink(t0) {
  const $ = _c(18);
  const {
    item
  } = t0;
  if (!item.shouldRender) {
    return null;
  }
  let T0;
  let T1;
  let t1;
  let t2;
  if ($[0] !== item) {
    const isActive = item.isActive(item.href);
    T1 = NavigationMenu.Item;
    T0 = NavigationMenu.Link;
    t1 = isActive;
    t2 = twJoin(getItemClassName(isActive), "px-2");
    $[0] = item;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== item.href || $[6] !== item.target) {
    t3 = <LinkWithoutPrefetch href={item.href} target={item.target} />;
    $[5] = item.href;
    $[6] = item.target;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== T0 || $[9] !== item.dataTestId || $[10] !== item.name || $[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <T0 active={t1} className={t2} data-test-id={item.dataTestId} render={t3}>{item.name}</T0>;
    $[8] = T0;
    $[9] = item.dataTestId;
    $[10] = item.name;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== T1 || $[16] !== t4) {
    t5 = <T1>{t4}</T1>;
    $[15] = T1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function DesktopDropdown(t0) {
  const $ = _c(23);
  const {
    item
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  if ($[0] !== item) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const isActive = isNestedMenuItemActive(item);
      if (!hasRenderableMenuItem(item.dropdownItems)) {
        t3 = null;
        break bb0;
      }
      T1 = NavigationMenu.Item;
      t2 = item.id;
      T0 = NavigationMenu.Trigger;
      t1 = twMerge(getItemClassName(isActive), DESKTOP_NAVBAR_DROPDOWN_PADDING_CLASS_NAME, "data-popup-open:bg-bg-tertiary data-popup-open:[&_svg]:rotate-180");
    }
    $[0] = item;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const t4 = `${item.id}-menu-button`;
  let t5;
  if ($[6] !== item.name) {
    t5 = <span className="min-w-0 truncate">{item.name}</span>;
    $[6] = item.name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownIcon className={twJoin("transition-base size-5", DESKTOP_NAVBAR_CHEVRON_CLASS_NAME)} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== T0 || $[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t7 = <T0 className={t1} data-test-id={t4}>{t5}{t6}</T0>;
    $[9] = T0;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== item.dropdownItems) {
    t8 = item.dropdownItems.map(_temp);
    $[14] = item.dropdownItems;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <NavigationMenu.Content className="flex flex-col">{t8}</NavigationMenu.Content>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== T1 || $[19] !== t2 || $[20] !== t7 || $[21] !== t9) {
    t10 = <T1 value={t2}>{t7}{t9}</T1>;
    $[18] = T1;
    $[19] = t2;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(dropdownItem) {
  return <DesktopDropdownRow item={dropdownItem} key={isMenuLink(dropdownItem) ? dropdownItem.href : dropdownItem.id} />;
}
function DesktopDropdownRow(t0) {
  const $ = _c(4);
  const {
    item
  } = t0;
  if (isMenuLink(item)) {
    let t1;
    if ($[0] !== item) {
      t1 = <DesktopDropdownLink item={item} />;
      $[0] = item;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== item) {
    t1 = <DesktopNestedDropdown item={item} />;
    $[2] = item;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}

/**
 * Second-level dropdown. A nested `NavigationMenu.Root` renders a `<div>` and owns its own popup,
 * so the flyout keeps the hover handover of the level above it instead of borrowing menu submenus.
 */
function DesktopNestedDropdown(t0) {
  const $ = _c(22);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = isNestedMenuItemActive(item);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActive = t1;
  if (!hasRenderableMenuItem(item.dropdownItems)) {
    return null;
  }
  const t2 = item.id;
  let t3;
  if ($[2] !== isActive) {
    t3 = twMerge(menuItemVariants({
      state: isActive ? "active" : "default"
    }), "data-popup-open:bg-bg-tertiary justify-between", DESKTOP_NAVBAR_CHEVRON_CHILD_CLASS_NAME);
    $[2] = isActive;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${item.id}-menu-button`;
  let t5;
  if ($[4] !== item.name) {
    t5 = <span className="min-w-0 truncate">{item.name}</span>;
    $[4] = item.name;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownIcon className="size-4 -rotate-90" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t7 = <NavigationMenu.Trigger className={t3} data-test-id={t4}>{t5}{t6}</NavigationMenu.Trigger>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== item.dropdownItems) {
    t8 = item.dropdownItems.map(_temp2);
    $[11] = item.dropdownItems;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <NavigationMenu.Content className="flex flex-col">{t8}</NavigationMenu.Content>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== item.id || $[16] !== t7 || $[17] !== t9) {
    t10 = <NavigationMenu.List><NavigationMenu.Item value={t2}>{t7}{t9}</NavigationMenu.Item></NavigationMenu.List>;
    $[15] = item.id;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <NavigationMenu.Portal><NavigationMenu.Positioner align="start" className="z-60" side="inline-end"><NavigationMenu.Popup><NavigationMenu.Viewport /></NavigationMenu.Popup></NavigationMenu.Positioner></NavigationMenu.Portal>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <NavigationMenu.Root>{t10}{t11}</NavigationMenu.Root>;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp2(dropdownItem) {
  return <DesktopDropdownRow item={dropdownItem} key={isMenuLink(dropdownItem) ? dropdownItem.href : dropdownItem.id} />;
}
function DesktopDropdownLink(t0) {
  const $ = _c(15);
  const {
    item
  } = t0;
  if (!item.shouldRender) {
    return null;
  }
  let t1;
  if ($[0] !== item) {
    t1 = item.isActive(item.href);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActive = t1;
  const t2 = isActive ? "active" : "default";
  let t3;
  if ($[2] !== t2) {
    t3 = menuItemVariants({
      state: t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== item.href || $[5] !== item.target) {
    t4 = <LinkWithoutPrefetch href={item.href} target={item.target} />;
    $[4] = item.href;
    $[5] = item.target;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== item.name) {
    t5 = <span className="min-w-0 truncate">{item.name}</span>;
    $[7] = item.name;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isActive || $[10] !== item.dataTestId || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <NavigationMenu.Link active={isActive} className={t3} data-test-id={item.dataTestId} render={t4}>{t5}</NavigationMenu.Link>;
    $[9] = isActive;
    $[10] = item.dataTestId;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}